import React, { Component } from 'react'
import { connect } from 'react-redux'
// import {Calendar} from 'react-date-range';
import Calendar from 'react-calendar';
import * as _ from 'lodash'
import 'react-calendar/dist/Calendar.css';
import {
  Col, Row,
  Icon,
  Button,
  FormControl,
  OverlayTrigger,
  FormGroup,
  InputGroup,
  PanelContainer,
  Panel
} from '@sketchpixy/rubix'
import {
  DISPLAY_FORMAT_DATE,
  START_CALENDER_FORMAT,
  DEFAULT_DATE_FORMAT,
} from '../utils'
import PropTypes from 'prop-types'
import WidgetBlocks from '../components/WidgetBlocks'
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import LoadingContainer from "../components/LoadingContainerReview";

class Home extends Component {
  constructor (props) {
    super(props)

    sessionStorage.removeItem('questionState');
    sessionStorage.removeItem('patient');
    sessionStorage.removeItem('currentDbq');
    sessionStorage.removeItem('page');
    sessionStorage.removeItem("current")
    sessionStorage.removeItem("src")
    sessionStorage.removeItem("fileUrl")
    sessionStorage.removeItem("selectedLicense")
    sessionStorage.removeItem("signedDbq")
    sessionStorage.removeItem("requiredSignRecords")
    
    let startDate = sessionStorage.getItem("startDate")
    let aptDate = sessionStorage.getItem("aptDate")
    this.state = {
      startDate: startDate ? startDate : moment().format(DISPLAY_FORMAT_DATE),
      aptDate: aptDate ? aptDate : moment().format("dddd, MMMM Do YYYY"),
      showCalender: false,
      totalPatients: 0,
      totalDBQ:0,
      activeApptDates: [],
      showSpinner: false,
      tileClass: "calendar-tile"
    }
  }

  componentDidMount() {
    sessionStorage.removeItem("examIsResumed")
    sessionStorage.removeItem("currentDiagnosesAndExtremities")
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function(event) {
      window.history.go(1);
    };
    let startDate = sessionStorage.getItem("startDate")
    let aptDate = sessionStorage.getItem("aptDate")
    this.setState ({
      startDate: startDate ? startDate : moment().format(DISPLAY_FORMAT_DATE),
      aptDate: aptDate ? aptDate : moment().format("dddd, MMMM Do YYYY"),
    })
    this._notificationSystem = this.refs.notificationSystem
    if (this.props.location && this.props.location.isSign) {
      this._addNotification();
    }

    this.getActiveApptDates();

  }

  getActiveApptDates = () => {
    let token = localStorage.getItem('login_token');
    let headers = {"Content-Type": "application/json"};
    headers["Authorization"] = `Bearer ${token}`
    fetch(process.env.API_URL+"/patients/appts/dates", {headers})
    .then(response => response.json())
    .then(data => {    
      this.setState({activeApptDates: data.apptDates, showSpinner: true})
      // console.log(JSON.stringify(this.state.activeApptDates))    
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } 

  _addNotification = () => {
    this._notificationSystem.clearNotifications()
    this._notificationSystem.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: 10,
        children: (
          <div style={{display: 'flex', width: '100%', paddingTop: '5px'}}>
            <div style={{width:"30%", lineHeight: '45px', paddingTop: '7px', paddingLeft: '15px'}}>
                <Icon glyph='glyphicon glyphicon-refresh glyphicon-spin' style={{fontSize: '2.7em'}}/>
            </div>
            <div style={{width:"69%"}}>
              <p style={{marginBottom: 0}}>Sending DBQ to VBG</p>
              <p style={{marginBottom: 0}}>Please don't close app ...</p>
            </div>
          </div>
        )
    })
  }

  showEmailConfirmation = () => {
    this._notificationSystem.clearNotifications()
    this._notificationSystem.addNotification({
        level: 'info',
        position: 'br',
        autoDismiss: 3,
        children: (
          <div style={{display: 'flex', width: '100%', paddingTop: '5px'}}>
            <div style={{width:"30%", lineHeight: '45px', paddingTop: '7px', paddingLeft: '15px'}}>
                <Icon glyph='glyphicon glyphicon-envelope' style={{fontSize: '2.7em'}}/>
            </div>
            <div style={{width:"69%"}}>
              <p style={{marginBottom: 0}}>Email has been sent !!!</p>
            </div>
          </div>
        )
    })
  }
 

  toggleCalender = () => {
    let {showCalender = false} = this.state
    this.setState({
      showCalender: !showCalender,
     // calenderFlag: !calenderFlag
    })
    
  }

  updateDate = (date) => {
    this.setState({
      showCalender: false,
      startDate: moment(date).format(DISPLAY_FORMAT_DATE),
      aptDate: moment(date).format("dddd, MMMM Do YYYY"),
    })

    sessionStorage.setItem("startDate", moment(date).format(DISPLAY_FORMAT_DATE))  
    sessionStorage.setItem("aptDate", moment(date).format("dddd, MMMM Do YYYY"))    
  }

  tileDisabled = ({date}) => {
    return !this.state.activeApptDates.find(dDate => moment(date).format(DISPLAY_FORMAT_DATE) === moment(dDate.appt_date_text_c).format(DISPLAY_FORMAT_DATE));
  }
  tileContent = ({ date, view }) => view === 'month' && date.getDay() === 0 ? <p>It's Sunday!</p> : null

  tileClassName = ({date}) => {
    console.log(JSON.stringify(date))
    console.log(moment(date).format(DISPLAY_FORMAT_DATE))
    console.log(moment(date).format(DISPLAY_FORMAT_DATE) === "17 March 2022")
      if(moment(date).format(DISPLAY_FORMAT_DATE) === "19 March 2022") {
        console.log("tileClassName")
        return 'calendar-tile';
      }
  }
  // selectedDate = ({date}) => {
  //   console.log(this.state.aptDate)
  //   // let dt = date.getYear() + ", "+ date.getMonth()+ ", "+ date.getDay()
  //   // console.log(dt)
  //   return new Date(this.state.aptDate.getYear(), this.state.aptDate.getMonth(), this.state.aptDate.getDay())
  // }

  onFocusChange = (event) => {
    if(event.relatedTarget === null) {
      this.setState({ showCalender: false});
    }
  }

  getTotalCounts = e => {
    this.setState({
      totalPatients: e.totalPatients,
      totalDBQ: e.totalDBQ
    })
  }


  actions = link => {
    const {history} = this.props
    this.props.routeChange()
    history.push(link)
  }

  submitClick = (link , pDoc) => {
    const {history} = this.props
    sessionStorage.setItem("pDoc", JSON.stringify(pDoc))
    sessionStorage.setItem("correctedIsTouched", "yes")
    history.push({pathname:link, pDoc})
  }

  loadReview = (link , signRecord) => {
    const {history} = this.props
    
    let patientProp = {id: signRecord.patient, name: signRecord.patientName, apptDate: signRecord.apptDt, ssn: signRecord.ssn, apptId: signRecord.apptId ? signRecord.apptId: ''}
    let currentDbqProp = {name: signRecord.name, name_fv: signRecord.name_fv, id: signRecord.dbqId}
    sessionStorage.setItem('questionState', JSON.stringify(signRecord.questions));
    sessionStorage.setItem('currentDbq', JSON.stringify(currentDbqProp));
    sessionStorage.setItem('patient', JSON.stringify(patientProp));

    history.push({pathname:link, currentDbq:currentDbqProp, questionState: signRecord.questions, patient:patientProp, page: "home"})
  }

  getPatientDocInfo = (patientDoc, aptDate, patientId, patientName, dbqCount) => {
    let tableRow = []
    for (let pDoc of patientDoc) {
      pDoc["patientId"] = patientId;
      pDoc["dbqId"] = pDoc.id;
      pDoc["patientName"] = patientName;
      pDoc["dbqCount"] = dbqCount;
      tableRow.push(
        <tr className="tr-corrected-dbq" key={pDoc.id} style={{fontSize: 16}}>
          <td></td>
          <td>{pDoc.patientName}</td>
          <td>{moment(aptDate).format(DEFAULT_DATE_FORMAT)}</td>
          <td>{pDoc.disabilityNameFv}</td>
          <td>
          <Button
              type='button'
              bsStyle='primary'
              className="btn"
              style={{textTransform: 'none',fontSize: 15, color: 'white', height: '35px', borderRadius: '10px', boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.25)'}}
              onClick={this.submitClick.bind(this, `/admin/compare`, pDoc)}> Review
              <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill='#fff' style={{marginLeft: 10, marginBottom: -3}}>
                <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/>
                </svg>
          </Button>
          </td>
        </tr> 
      )
    }
    return tableRow
  }


  render () {
    const { startDate, showCalender = false, totalDBQ, totalPatients, aptDate } = this.state
    let style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          // margin: '100px'
          "padding": '10px',
          "background-color": '#022144',
          "border-radius" : "10px",
          "color" : "white",
          // "padding-bottom" : "10px",
          "border-top": "none"
        }
      }
    }

    return (
      <div className={'home-containers show-with-ease'}>
        
        <Row>
          <Col md={6} sm={7} >
            <h2 className='heading-main' style={{marginTop: 0, marginBottom:0}}>
              <strong>Your Appointments for {aptDate}</strong>
            </h2>
            <Row className="mt-20">
            <Col xs={6} sm={4} md={4} lg={4}>
                <PanelContainer className='vbg-card-shadow'>
                  <Panel className="text-center">
                      <p className='font-weight-600' style={{fontSize: '13px'}}>Total DBQs</p>
                      <p className='heading-main fg-black'>{totalDBQ ? totalDBQ: 0}</p>
                  </Panel>
                </PanelContainer>
              </Col>
              <Col xs={6} sm={4} md={4} lg={4}>
                <PanelContainer className='vbg-card-shadow'>
                  <Panel className="text-center">
                      <p className='font-weight-600' style={{fontSize: '13px'}}>Total Patients</p>
                      <p className='heading-main fg-black'>{totalPatients? totalPatients: 0}</p>
                  </Panel>
                </PanelContainer>
              </Col>
            </Row>
            {/* <p className="fg-blue font-weight-600" style={{margin: '10px', fontSize: '18px'}}>
              Select DBQ to Begin
            </p> */}
          </Col>
          <Col md={6} sm={5} xs={6} >
          <OverlayTrigger placement="bottom" overlay={toolTip('Select date')}>
          <FormGroup >
            <InputGroup className='vbg-card-shadow pull-right calendar-span-width'>
              <FormControl
                  style={{border: 'none', height: '50px', zIndex: 0}} 
                  className="bg-white fg-blue"
                  type='text'
                  id='formGroupInputLarge'
                  onClick={this.toggleCalender}
                  onBlur={this.onFocusChange}
                  readOnly
                  value={startDate}
                  placeholder='Start Date'/>
                  <InputGroup.Addon
                    className="bg-white fg-blue"
                    onClick={this.toggleCalender} 
                    >
                    <Icon onBlur={this.onFocusChange} tabIndex="1" glyph='glyphicon glyphicon-calendar'/>
                  </InputGroup.Addon>
            </InputGroup>
            
          </FormGroup>
          </OverlayTrigger>
          
          </Col>
        </Row>
        {
          this.state.showSpinner ? "": 
          <LoadingContainer />
        }
        {/* <Row style={{paddingLeft: 25, paddingRight: 25, display: requiredSignRecords.length > 0 ? "block": "none"}}>
          <h2 className='heading-main' style={{marginTop: 0, marginBottom:0}}>
              <strong>Requires Signature</strong>
          </h2>
          <h6 className='' style={{marginTop: 5, marginBottom:0, fontSize: 16}}>
              <strong>The following DBQs have been answered and require signature</strong>
          </h6>
          <Col sm={12} className="correct-dbq-panel" style={{marginTop: "1%", padding: 0}}>
            <table style={{width:'100%'}}>
              <thead>
                <tr className="tr-corrected-dbq" >
                  <th style={{width:'5%'}}></th>
                  <th style={{width:'30%'}}>Patient</th>
                  <th style={{width:'20%'}}>Appointment Date</th>
                  <th style={{width:'30%'}}>DBQ</th>
                  <th style={{width:'15%'}}></th>
                </tr>
              </thead>
              {
                requiredSignRecords && requiredSignRecords.length > 0 && requiredSignRecords.map((signRecord, index) => (
                  <tbody key={`signRecord-${index}`}>
                    <tr className="tr-corrected-dbq" key={signRecord.id} style={{fontSize: 16}}>
                    <td></td>
                    <td>{signRecord.patientName}</td>
                    <td>{moment(signRecord.apptDt ? signRecord.apptDt : signRecord.createdAt).format(DEFAULT_DATE_FORMAT)}</td>
                    <td>{signRecord.name_fv}</td>
                    <td>
                    <Button
                        type='button'
                        bsStyle='primary'
                        className="btn"
                        style={{textTransform: 'none',fontSize: 15, color: 'white', height: '35px', borderRadius: '10px', boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.25)'}}
                        onClick={this.loadReview.bind(this, `/admin/review`, signRecord)}> Sign
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill='#fff' style={{marginLeft: 10, marginBottom: -3}}>
                          <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/>
                          </svg>
                    </Button>
                    </td>
                  </tr> 
                  </tbody>
                  
                ))
              }
            </table>
          </Col>
        </Row><br /> */}
        {/* <Row style={{paddingLeft: 25, paddingRight: 25, display: correctedDbqRecords.length > 0 ? "block": "none"}}>
          <h2 className='heading-main' style={{marginTop: 0, marginBottom:0}}>
              <strong>Needs Review</strong>
          </h2>
          <h6 className='' style={{marginTop: 5, marginBottom:0, fontSize: 16}}>
              <strong>The following DBQs have been edited by VBG and require your review</strong>
          </h6>
          <Col sm={12} className="correct-dbq-panel animate__animated animate__fadeIn" style={{marginTop: "1%", padding: 0}}>
            <table style={{width:'100%'}}>
              <thead>
                <tr className="tr-corrected-dbq" >
                  <th style={{width:'5%'}}></th>
                  <th style={{width:'30%'}}>Patient</th>
                  <th style={{width:'20%'}}>Appointment Date</th>
                  <th style={{width:'30%'}}>DBQ</th>
                  <th style={{width:'15%'}}></th>
                </tr>
              </thead>
              {
                correctedDbqRecords && correctedDbqRecords.length > 0 && correctedDbqRecords.map((correctedRecord, index) => (
                  <tbody key={index}>
                    {this.getPatientDocInfo(correctedRecord.patientDoc, correctedRecord.appointmentDate, correctedRecord.patientId, correctedRecord.patientName, correctedRecord.dbqCount)}
                  </tbody>
                  
                ))
              }
            </table>
          </Col>
        </Row> */}
        
        <p className="fg-blue font-weight-600" style={{margin: '10px', fontSize: '18px'}}>
              Select DBQ to Begin
            </p>
        {showCalender ?
              <div className="pull-right date-picker-d" onBlur={this.onFocusChange} tabIndex="-1" style={{marginTop: '22px', marginRight: '-5px', borderRadius: '10px'}}>
                    <Calendar
                      // months = {2}
                      calendarType = {"US"}
                      className = {"calendar-disable-date"}
                      // tileClassName={"calendar-tile-highlight"}
                      // focusedInput={this.state.showCalender}
                      // date={moment(startDate).format(START_CALENDER_FORMAT)}
                      //value={new Date(2022, 3, 10)}
                      value={new Date()}
                      // defaultActiveStartDate={new Date()}
                      onChange={this.updateDate}
                      // defaultView="month"
                      // view="month"
                      onViewChange={({ view }) => this.setState({showCalender: false})}
                      // onViewChange={this.onViewChange}
                      tileDisabled={this.tileDisabled}
                      
                    />
              </div>
            : null}
        
        <WidgetBlocks {...this.props} onChangeValue={this.getTotalCounts} startDate={startDate} onEmailSent={this.showEmailConfirmation}/>
        <NotificationSystem ref='notificationSystem' style={style}/>
      </div>
    )
  }
}

Home.propTypes = {
  routeChange: PropTypes.func
}

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps =
  ({
     login: {
       role
     }
   }) => ({
     role
   })

export const toolTip = (msg) => {
    //return (<Tooltip id='tooltip'></Tooltip>)
    return (<span id='tooltip'></span>)
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
